var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a, _b;
/*!
  * vue-i18n v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
import { getGlobalThis, format, makeSymbol, isObject, create, isPlainObject, isArray, deepCopy, isString, hasOwn, warn, isBoolean, isRegExp, isFunction, inBrowser, assign, isNumber, warnOnce, createEmitter, isEmptyObject } from '@intlify/shared';
import { CORE_WARN_CODES_EXTEND_POINT, CORE_ERROR_CODES_EXTEND_POINT, createCompileError, isMessageAST, AST_NODE_PROPS_KEYS, DEFAULT_LOCALE, updateFallbackLocale, setFallbackContext, createCoreContext, clearDateTimeFormat, clearNumberFormat, setAdditionalMeta, getFallbackContext, NOT_REOSLVED, isTranslateFallbackWarn, isTranslateMissingWarn, parseTranslateArgs, translate, MISSING_RESOLVE_VALUE, parseDateTimeArgs, datetime, parseNumberArgs, number, isMessageFunction, fallbackWithLocaleChain, NUMBER_FORMAT_OPTIONS_KEYS, DATETIME_FORMAT_OPTIONS_KEYS, registerMessageCompiler, compile, registerMessageResolver, resolveValue, registerLocaleFallbacker, setDevToolsHook } from '@intlify/core-base';
import { createVNode, Text, computed, watch, getCurrentInstance, ref, shallowRef, Fragment, defineComponent, h, effectScope, inject, onMounted, onUnmounted, isRef } from 'vue';
import { setupDevtoolsPlugin } from '@vue/devtools-api';
/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */
var VERSION = '10.0.8';
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */
function initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== 'boolean') {
        getGlobalThis().__VUE_I18N_FULL_INSTALL__ = true;
    }
    if (typeof __VUE_I18N_LEGACY_API__ !== 'boolean') {
        getGlobalThis().__VUE_I18N_LEGACY_API__ = true;
    }
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') {
        getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    }
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') {
        getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
}
var I18nWarnCodes = {
    FALLBACK_TO_ROOT: CORE_WARN_CODES_EXTEND_POINT, // 8
    NOT_FOUND_PARENT_SCOPE: 9,
    IGNORE_OBJ_FLATTEN: 10,
    DEPRECATE_TC: 11
};
var warnMessages = (_a = {},
    _a[I18nWarnCodes.FALLBACK_TO_ROOT] = "Fall back to {type} '{key}' with root locale.",
    _a[I18nWarnCodes.NOT_FOUND_PARENT_SCOPE] = "Not found parent scope. use the global scope.",
    _a[I18nWarnCodes.IGNORE_OBJ_FLATTEN] = "Ignore object flatten: '{key}' key has an string value",
    _a[I18nWarnCodes.DEPRECATE_TC] = "'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc\u2019 are going to remove in v11.",
    _a);
function getWarnMessage(code) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return format.apply(void 0, __spreadArray([warnMessages[code]], __read(args), false));
}
var I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: CORE_ERROR_CODES_EXTEND_POINT, // 24
    // legacy module errors
    INVALID_ARGUMENT: 25,
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: 26,
    NOT_INSTALLED: 27,
    // directive module errors
    REQUIRED_VALUE: 28,
    INVALID_VALUE: 29,
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
    NOT_INSTALLED_WITH_PROVIDE: 31,
    // unexpected error
    UNEXPECTED_ERROR: 32,
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function createI18nError(code) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return createCompileError(code, null, (process.env.NODE_ENV !== 'production') ? { messages: errorMessages, args: args } : undefined);
}
var errorMessages = (_b = {},
    _b[I18nErrorCodes.UNEXPECTED_RETURN_TYPE] = 'Unexpected return type in composer',
    _b[I18nErrorCodes.INVALID_ARGUMENT] = 'Invalid argument',
    _b[I18nErrorCodes.MUST_BE_CALL_SETUP_TOP] = 'Must be called at the top of a `setup` function',
    _b[I18nErrorCodes.NOT_INSTALLED] = 'Need to install with `app.use` function',
    _b[I18nErrorCodes.UNEXPECTED_ERROR] = 'Unexpected error',
    _b[I18nErrorCodes.REQUIRED_VALUE] = "Required in value: {0}",
    _b[I18nErrorCodes.INVALID_VALUE] = "Invalid value",
    _b[I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN] = "Cannot setup vue-devtools plugin",
    _b[I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE] = 'Need to install with `provide` function',
    _b[I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N] = 'Not compatible legacy VueI18n.',
    _b[I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY] = 'Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly',
    _b);
var TranslateVNodeSymbol = 
/* #__PURE__*/ makeSymbol('__translateVNode');
var DatetimePartsSymbol = /* #__PURE__*/ makeSymbol('__datetimeParts');
var NumberPartsSymbol = /* #__PURE__*/ makeSymbol('__numberParts');
var EnableEmitter = /* #__PURE__*/ makeSymbol('__enableEmitter');
var DisableEmitter = /* #__PURE__*/ makeSymbol('__disableEmitter');
var SetPluralRulesSymbol = makeSymbol('__setPluralRules');
makeSymbol('__intlifyMeta');
var InejctWithOptionSymbol = 
/* #__PURE__*/ makeSymbol('__injectWithOption');
var DisposeSymbol = /* #__PURE__*/ makeSymbol('__dispose');
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Transform flat json in obj to normal json in obj
 */
function handleFlatJson(obj) {
    // check obj
    if (!isObject(obj)) {
        return obj;
    }
    if (isMessageAST(obj)) {
        return obj;
    }
    for (var key in obj) {
        // check key
        if (!hasOwn(obj, key)) {
            continue;
        }
        // handle for normal json
        if (!key.includes('.')) {
            // recursive process value if value is also a object
            if (isObject(obj[key])) {
                handleFlatJson(obj[key]);
            }
        }
        // handle for flat json, transform to normal json
        else {
            // go to the last object
            var subKeys = key.split('.');
            var lastIndex = subKeys.length - 1;
            var currentObj = obj;
            var hasStringValue = false;
            for (var i = 0; i < lastIndex; i++) {
                if (subKeys[i] === '__proto__') {
                    throw new Error("unsafe key: ".concat(subKeys[i]));
                }
                if (!(subKeys[i] in currentObj)) {
                    currentObj[subKeys[i]] = create();
                }
                if (!isObject(currentObj[subKeys[i]])) {
                    (process.env.NODE_ENV !== 'production') &&
                        warn(getWarnMessage(I18nWarnCodes.IGNORE_OBJ_FLATTEN, {
                            key: subKeys[i]
                        }));
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                if (!isMessageAST(currentObj)) {
                    currentObj[subKeys[lastIndex]] = obj[key];
                    delete obj[key];
                }
                else {
                    /**
                     * NOTE:
                     * if the last object is a message AST and subKeys[lastIndex] has message AST prop key, ignore to copy and key deletion
                     */
                    if (!AST_NODE_PROPS_KEYS.includes(subKeys[lastIndex])) {
                        delete obj[key];
                    }
                }
            }
            // recursive process value if value is also a object
            if (!isMessageAST(currentObj)) {
                var target = currentObj[subKeys[lastIndex]];
                if (isObject(target)) {
                    handleFlatJson(target);
                }
            }
        }
    }
    return obj;
}
function getLocaleMessages(locale, options) {
    var _a;
    var messages = options.messages, __i18n = options.__i18n, messageResolver = options.messageResolver, flatJson = options.flatJson;
    // prettier-ignore
    var ret = (isPlainObject(messages)
        ? messages
        : isArray(__i18n)
            ? create()
            : (_a = {}, _a[locale] = create(), _a));
    // merge locale messages of i18n custom block
    if (isArray(__i18n)) {
        __i18n.forEach(function (custom) {
            if ('locale' in custom && 'resource' in custom) {
                var locale_1 = custom.locale, resource = custom.resource;
                if (locale_1) {
                    ret[locale_1] = ret[locale_1] || create();
                    deepCopy(resource, ret[locale_1]);
                }
                else {
                    deepCopy(resource, ret);
                }
            }
            else {
                isString(custom) && deepCopy(JSON.parse(custom), ret);
            }
        });
    }
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for (var key in ret) {
            if (hasOwn(ret, key)) {
                handleFlatJson(ret[key]);
            }
        }
    }
    return ret;
}
function getComponentOptions(instance) {
    return instance.type;
}
function adjustI18nResources(gl, options, componentOptions) {
    // prettier-ignore
    var messages = isObject(options.messages)
        ? options.messages
        : create();
    if ('__i18nGlobal' in componentOptions) {
        messages = getLocaleMessages(gl.locale.value, {
            messages: messages,
            __i18n: componentOptions.__i18nGlobal
        });
    }
    // merge locale messages
    var locales = Object.keys(messages);
    if (locales.length) {
        locales.forEach(function (locale) {
            gl.mergeLocaleMessage(locale, messages[locale]);
        });
    }
    {
        // merge datetime formats
        if (isObject(options.datetimeFormats)) {
            var locales_1 = Object.keys(options.datetimeFormats);
            if (locales_1.length) {
                locales_1.forEach(function (locale) {
                    gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
                });
            }
        }
        // merge number formats
        if (isObject(options.numberFormats)) {
            var locales_2 = Object.keys(options.numberFormats);
            if (locales_2.length) {
                locales_2.forEach(function (locale) {
                    gl.mergeNumberFormat(locale, options.numberFormats[locale]);
                });
            }
        }
    }
}
function createTextNode(key) {
    return createVNode(Text, null, key, 0);
}
/* eslint-disable @typescript-eslint/no-explicit-any */
// extend VNode interface
var DEVTOOLS_META = '__INTLIFY_META__';
var NOOP_RETURN_ARRAY = function () { return []; };
var NOOP_RETURN_FALSE = function () { return false; };
var composerID = 0;
function defineCoreMissingHandler(missing) {
    return (function (ctx, locale, key, type) {
        return missing(locale, key, getCurrentInstance() || undefined, type);
    });
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */
var getMetaInfo = function () {
    var _a;
    var instance = getCurrentInstance();
    var meta = null;
    return instance && (meta = getComponentOptions(instance)[DEVTOOLS_META])
        ? (_a = {}, _a[DEVTOOLS_META] = meta, _a) : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */
function createComposer(options) {
    var _a, _b, _c;
    if (options === void 0) { options = {}; }
    var __root = options.__root, __injectWithOption = options.__injectWithOption;
    var _isGlobal = __root === undefined;
    var flatJson = options.flatJson;
    var _ref = inBrowser ? ref : shallowRef;
    var _inheritLocale = isBoolean(options.inheritLocale)
        ? options.inheritLocale
        : true;
    var _locale = _ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.locale.value
        : isString(options.locale)
            ? options.locale
            : DEFAULT_LOCALE);
    var _fallbackLocale = _ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.fallbackLocale.value
        : isString(options.fallbackLocale) ||
            isArray(options.fallbackLocale) ||
            isPlainObject(options.fallbackLocale) ||
            options.fallbackLocale === false
            ? options.fallbackLocale
            : _locale.value);
    var _messages = _ref(getLocaleMessages(_locale.value, options));
    // prettier-ignore
    var _datetimeFormats = _ref(isPlainObject(options.datetimeFormats)
        ? options.datetimeFormats
        : (_a = {}, _a[_locale.value] = {}, _a));
    // prettier-ignore
    var _numberFormats = _ref(isPlainObject(options.numberFormats)
        ? options.numberFormats
        : (_b = {}, _b[_locale.value] = {}, _b));
    // warning suppress options
    // prettier-ignore
    var _missingWarn = __root
        ? __root.missingWarn
        : isBoolean(options.missingWarn) || isRegExp(options.missingWarn)
            ? options.missingWarn
            : true;
    // prettier-ignore
    var _fallbackWarn = __root
        ? __root.fallbackWarn
        : isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn)
            ? options.fallbackWarn
            : true;
    // prettier-ignore
    var _fallbackRoot = __root
        ? __root.fallbackRoot
        : isBoolean(options.fallbackRoot)
            ? options.fallbackRoot
            : true;
    // configure fall back to root
    var _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    var _missing = isFunction(options.missing) ? options.missing : null;
    var _runtimeMissing = isFunction(options.missing)
        ? defineCoreMissingHandler(options.missing)
        : null;
    // postTranslation handler
    var _postTranslation = isFunction(options.postTranslation)
        ? options.postTranslation
        : null;
    // prettier-ignore
    var _warnHtmlMessage = __root
        ? __root.warnHtmlMessage
        : isBoolean(options.warnHtmlMessage)
            ? options.warnHtmlMessage
            : true;
    var _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    var _modifiers = __root
        ? __root.modifiers
        : isPlainObject(options.modifiers)
            ? options.modifiers
            : {};
    // pluralRules
    var _pluralRules = options.pluralRules || (__root && __root.pluralRules);
    // runtime context
    // eslint-disable-next-line prefer-const
    var _context;
    var getCoreContext = function () {
        _isGlobal && setFallbackContext(null);
        var ctxOptions = {
            version: VERSION,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: { framework: 'vue' }
        };
        {
            ctxOptions.datetimeFormats = _datetimeFormats.value;
            ctxOptions.numberFormats = _numberFormats.value;
            ctxOptions.__datetimeFormatters = isPlainObject(_context)
                ? _context.__datetimeFormatters
                : undefined;
            ctxOptions.__numberFormatters = isPlainObject(_context)
                ? _context.__numberFormatters
                : undefined;
        }
        if ((process.env.NODE_ENV !== 'production')) {
            ctxOptions.__v_emitter = isPlainObject(_context)
                ? _context.__v_emitter
                : undefined;
        }
        var ctx = createCoreContext(ctxOptions);
        _isGlobal && setFallbackContext(ctx);
        return ctx;
    };
    _context = getCoreContext();
    updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    var locale = computed({
        get: function () { return _locale.value; },
        set: function (val) {
            _locale.value = val;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    var fallbackLocale = computed({
        get: function () { return _fallbackLocale.value; },
        set: function (val) {
            _fallbackLocale.value = val;
            _context.fallbackLocale = _fallbackLocale.value;
            updateFallbackLocale(_context, _locale.value, val);
        }
    });
    // messages
    var messages = computed(function () { return _messages.value; });
    // datetimeFormats
    var datetimeFormats = /* #__PURE__*/ computed(function () { return _datetimeFormats.value; });
    // numberFormats
    var numberFormats = /* #__PURE__*/ computed(function () { return _numberFormats.value; });
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return isFunction(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler) {
        _postTranslation = handler;
        _context.postTranslation = handler;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler) {
        if (handler !== null) {
            _runtimeMissing = defineCoreMissingHandler(handler);
        }
        _missing = handler;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg) {
        return type !== 'translate' || !arg.resolvedMessage;
    }
    var wrapWithDeps = function (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) {
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        var ret;
        try {
            if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) {
                setAdditionalMeta(getMetaInfo());
            }
            if (!_isGlobal) {
                _context.fallbackContext = __root
                    ? getFallbackContext()
                    : undefined;
            }
            ret = fn(_context);
        }
        finally {
            if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) {
                setAdditionalMeta(null);
            }
            if (!_isGlobal) {
                _context.fallbackContext = undefined;
            }
        }
        if ((warnType !== 'translate exists' && // for not `te` (e.g `t`)
            isNumber(ret) &&
            ret === NOT_REOSLVED) ||
            (warnType === 'translate exists' && !ret) // for `te`
        ) {
            var _a = __read(argumentParser(), 2), key = _a[0], arg2 = _a[1];
            if ((process.env.NODE_ENV !== 'production') &&
                __root &&
                isString(key) &&
                isResolvedTranslateMessage(warnType, arg2)) {
                if (_fallbackRoot &&
                    (isTranslateFallbackWarn(_fallbackWarn, key) ||
                        isTranslateMissingWarn(_missingWarn, key))) {
                    warn(getWarnMessage(I18nWarnCodes.FALLBACK_TO_ROOT, {
                        key: key,
                        type: warnType
                    }));
                }
                // for vue-devtools timeline event
                if ((process.env.NODE_ENV !== 'production')) {
                    var emitter = _context.__v_emitter;
                    if (emitter && _fallbackRoot) {
                        emitter.emit('fallback', {
                            type: warnType,
                            key: key,
                            to: 'global',
                            groupId: "".concat(warnType, ":").concat(key)
                        });
                    }
                }
            }
            return __root && _fallbackRoot
                ? fallbackSuccess(__root)
                : fallbackFail(key);
        }
        else if (successCondition(ret)) {
            return ret;
        }
        else {
            /* istanbul ignore next */
            throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
        }
    };
    // t
    function t() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wrapWithDeps(function (context) { return Reflect.apply(translate, null, __spreadArray([context], __read(args), false)); }, function () { return parseTranslateArgs.apply(void 0, __spreadArray([], __read(args), false)); }, 'translate', function (root) { return Reflect.apply(root.t, root, __spreadArray([], __read(args), false)); }, function (key) { return key; }, function (val) { return isString(val); });
    }
    // rt
    function rt() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = __read(args, 3), arg1 = _a[0], arg2 = _a[1], arg3 = _a[2];
        if (arg3 && !isObject(arg3)) {
            throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        return t.apply(void 0, [arg1, arg2, assign({ resolvedMessage: true }, arg3 || {})]);
    }
    // d
    function d() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wrapWithDeps(function (context) { return Reflect.apply(datetime, null, __spreadArray([context], __read(args), false)); }, function () { return parseDateTimeArgs.apply(void 0, __spreadArray([], __read(args), false)); }, 'datetime format', function (root) { return Reflect.apply(root.d, root, __spreadArray([], __read(args), false)); }, function () { return MISSING_RESOLVE_VALUE; }, function (val) { return isString(val); });
    }
    // n
    function n() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wrapWithDeps(function (context) { return Reflect.apply(number, null, __spreadArray([context], __read(args), false)); }, function () { return parseNumberArgs.apply(void 0, __spreadArray([], __read(args), false)); }, 'number format', function (root) { return Reflect.apply(root.n, root, __spreadArray([], __read(args), false)); }, function () { return MISSING_RESOLVE_VALUE; }, function (val) { return isString(val); });
    }
    // for custom processor
    function normalize(values) {
        return values.map(function (val) { return isString(val) || isNumber(val) || isBoolean(val)
            ? createTextNode(String(val))
            : val; });
    }
    var interpolate = function (val) { return val; };
    var processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: 'vnode'
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wrapWithDeps(function (context) {
            var ret;
            var _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply(translate, null, __spreadArray([_context], __read(args), false));
            }
            finally {
                _context.processor = null;
            }
            return ret;
        }, function () { return parseTranslateArgs.apply(void 0, __spreadArray([], __read(args), false)); }, 'translate', function (root) { return root[TranslateVNodeSymbol].apply(root, __spreadArray([], __read(args), false)); }, function (key) { return [createTextNode(key)]; }, function (val) { return isArray(val); });
    }
    // numberParts, using for `i18n-n` component
    function numberParts() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wrapWithDeps(function (context) { return Reflect.apply(number, null, __spreadArray([context], __read(args), false)); }, function () { return parseNumberArgs.apply(void 0, __spreadArray([], __read(args), false)); }, 'number format', function (root) { return root[NumberPartsSymbol].apply(root, __spreadArray([], __read(args), false)); }, NOOP_RETURN_ARRAY, function (val) { return isString(val) || isArray(val); });
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return wrapWithDeps(function (context) { return Reflect.apply(datetime, null, __spreadArray([context], __read(args), false)); }, function () { return parseDateTimeArgs.apply(void 0, __spreadArray([], __read(args), false)); }, 'datetime format', function (root) { return root[DatetimePartsSymbol].apply(root, __spreadArray([], __read(args), false)); }, NOOP_RETURN_ARRAY, function (val) { return isString(val) || isArray(val); });
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(function () {
            if (!key) {
                return false;
            }
            var targetLocale = isString(locale) ? locale : _locale.value;
            var message = getLocaleMessage(targetLocale);
            var resolved = _context.messageResolver(message, key);
            return (isMessageAST(resolved) ||
                isMessageFunction(resolved) ||
                isString(resolved));
        }, function () { return [key]; }, 'translate exists', function (root) {
            return Reflect.apply(root.te, root, [key, locale]);
        }, NOOP_RETURN_FALSE, function (val) { return isBoolean(val); });
    }
    function resolveMessages(key) {
        var messages = null;
        var locales = fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
        for (var i = 0; i < locales.length; i++) {
            var targetLocaleMessages = _messages.value[locales[i]] || {};
            var messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        var messages = resolveMessages(key);
        // prettier-ignore
        return messages != null
            ? messages
            : __root
                ? __root.tm(key) || {}
                : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return (_messages.value[locale] || {});
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        var _a;
        if (flatJson) {
            var _message = (_a = {}, _a[locale] = message, _a);
            for (var key in _message) {
                if (hasOwn(_message, key)) {
                    handleFlatJson(_message[key]);
                }
            }
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        var _a;
        _messages.value[locale] = _messages.value[locale] || {};
        var _message = (_a = {}, _a[locale] = message, _a);
        if (flatJson) {
            for (var key in _message) {
                if (hasOwn(_message, key)) {
                    handleFlatJson(_message[key]);
                }
            }
        }
        message = _message[locale];
        deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = assign(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = assign(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // for debug
    composerID++;
    // watch root locale & fallbackLocale
    if (__root && inBrowser) {
        watch(__root.locale, function (val) {
            if (_inheritLocale) {
                _locale.value = val;
                _context.locale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
        watch(__root.fallbackLocale, function (val) {
            if (_inheritLocale) {
                _fallbackLocale.value = val;
                _context.fallbackLocale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    var composer = (_c = {
            id: composerID,
            locale: locale,
            fallbackLocale: fallbackLocale,
            get inheritLocale() {
                return _inheritLocale;
            },
            set inheritLocale(val) {
                _inheritLocale = val;
                if (val && __root) {
                    _locale.value = __root.locale.value;
                    _fallbackLocale.value = __root.fallbackLocale.value;
                    updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
                }
            },
            get availableLocales() {
                return Object.keys(_messages.value).sort();
            },
            messages: messages,
            get modifiers() {
                return _modifiers;
            },
            get pluralRules() {
                return _pluralRules || {};
            },
            get isGlobal() {
                return _isGlobal;
            },
            get missingWarn() {
                return _missingWarn;
            },
            set missingWarn(val) {
                _missingWarn = val;
                _context.missingWarn = _missingWarn;
            },
            get fallbackWarn() {
                return _fallbackWarn;
            },
            set fallbackWarn(val) {
                _fallbackWarn = val;
                _context.fallbackWarn = _fallbackWarn;
            },
            get fallbackRoot() {
                return _fallbackRoot;
            },
            set fallbackRoot(val) {
                _fallbackRoot = val;
            },
            get fallbackFormat() {
                return _fallbackFormat;
            },
            set fallbackFormat(val) {
                _fallbackFormat = val;
                _context.fallbackFormat = _fallbackFormat;
            },
            get warnHtmlMessage() {
                return _warnHtmlMessage;
            },
            set warnHtmlMessage(val) {
                _warnHtmlMessage = val;
                _context.warnHtmlMessage = val;
            },
            get escapeParameter() {
                return _escapeParameter;
            },
            set escapeParameter(val) {
                _escapeParameter = val;
                _context.escapeParameter = val;
            },
            t: t,
            getLocaleMessage: getLocaleMessage,
            setLocaleMessage: setLocaleMessage,
            mergeLocaleMessage: mergeLocaleMessage,
            getPostTranslationHandler: getPostTranslationHandler,
            setPostTranslationHandler: setPostTranslationHandler,
            getMissingHandler: getMissingHandler,
            setMissingHandler: setMissingHandler
        },
        _c[SetPluralRulesSymbol] = setPluralRules,
        _c);
    {
        composer.datetimeFormats = datetimeFormats;
        composer.numberFormats = numberFormats;
        composer.rt = rt;
        composer.te = te;
        composer.tm = tm;
        composer.d = d;
        composer.n = n;
        composer.getDateTimeFormat = getDateTimeFormat;
        composer.setDateTimeFormat = setDateTimeFormat;
        composer.mergeDateTimeFormat = mergeDateTimeFormat;
        composer.getNumberFormat = getNumberFormat;
        composer.setNumberFormat = setNumberFormat;
        composer.mergeNumberFormat = mergeNumberFormat;
        composer[InejctWithOptionSymbol] = __injectWithOption;
        composer[TranslateVNodeSymbol] = translateVNode;
        composer[DatetimePartsSymbol] = datetimeParts;
        composer[NumberPartsSymbol] = numberParts;
    }
    // for vue-devtools timeline event
    if ((process.env.NODE_ENV !== 'production')) {
        composer[EnableEmitter] = function (emitter) {
            _context.__v_emitter = emitter;
        };
        composer[DisableEmitter] = function () {
            _context.__v_emitter = undefined;
        };
    }
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */
var VUE_I18N_COMPONENT_TYPES = 'vue-i18n: composer properties';
var VueDevToolsLabels = {
    'vue-devtools-plugin-vue-i18n': 'Vue I18n DevTools',
    'vue-i18n-resource-inspector': 'Vue I18n DevTools',
    'vue-i18n-timeline': 'Vue I18n'
};
var VueDevToolsPlaceholders = {
    'vue-i18n-resource-inspector': 'Search for scopes ...'
};
var VueDevToolsTimelineColors = {
    'vue-i18n-timeline': 0xffcd19
};
var devtoolsApi;
function enableDevTools(app, i18n) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    try {
                        setupDevtoolsPlugin({
                            id: 'vue-devtools-plugin-vue-i18n',
                            label: VueDevToolsLabels['vue-devtools-plugin-vue-i18n'],
                            packageName: 'vue-i18n',
                            homepage: 'https://vue-i18n.intlify.dev',
                            logo: 'https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png',
                            componentStateTypes: [VUE_I18N_COMPONENT_TYPES],
                            app: app // eslint-disable-line @typescript-eslint/no-explicit-any
                        }, function (api) {
                            devtoolsApi = api;
                            api.on.visitComponentTree(function (_a) {
                                var componentInstance = _a.componentInstance, treeNode = _a.treeNode;
                                updateComponentTreeTags(componentInstance, treeNode, i18n);
                            });
                            api.on.inspectComponent(function (_a) {
                                var componentInstance = _a.componentInstance, instanceData = _a.instanceData;
                                if (componentInstance.vnode.el &&
                                    componentInstance.vnode.el.__VUE_I18N__ &&
                                    instanceData) {
                                    if (i18n.mode === 'legacy') {
                                        // ignore global scope on legacy mode
                                        if (componentInstance.vnode.el.__VUE_I18N__ !==
                                            i18n.global.__composer) {
                                            inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                                        }
                                    }
                                    else {
                                        inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                                    }
                                }
                            });
                            api.addInspector({
                                id: 'vue-i18n-resource-inspector',
                                label: VueDevToolsLabels['vue-i18n-resource-inspector'],
                                icon: 'language',
                                treeFilterPlaceholder: VueDevToolsPlaceholders['vue-i18n-resource-inspector']
                            });
                            api.on.getInspectorTree(function (payload) {
                                if (payload.app === app &&
                                    payload.inspectorId === 'vue-i18n-resource-inspector') {
                                    registerScope(payload, i18n);
                                }
                            });
                            var roots = new Map();
                            api.on.getInspectorState(function (payload) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, root, instance;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (!(payload.app === app &&
                                                payload.inspectorId === 'vue-i18n-resource-inspector')) return [3 /*break*/, 4];
                                            api.unhighlightElement();
                                            inspectScope(payload, i18n);
                                            if (!(payload.nodeId === 'global')) return [3 /*break*/, 3];
                                            if (!!roots.has(payload.app)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, api.getComponentInstances(payload.app)];
                                        case 1:
                                            _a = __read.apply(void 0, [_b.sent(), 1]), root = _a[0];
                                            roots.set(payload.app, root);
                                            _b.label = 2;
                                        case 2:
                                            api.highlightElement(roots.get(payload.app));
                                            return [3 /*break*/, 4];
                                        case 3:
                                            instance = getComponentInstance(payload.nodeId, i18n);
                                            instance && api.highlightElement(instance);
                                            _b.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); });
                            api.on.editInspectorState(function (payload) {
                                if (payload.app === app &&
                                    payload.inspectorId === 'vue-i18n-resource-inspector') {
                                    editScope(payload, i18n);
                                }
                            });
                            api.addTimelineLayer({
                                id: 'vue-i18n-timeline',
                                label: VueDevToolsLabels['vue-i18n-timeline'],
                                color: VueDevToolsTimelineColors['vue-i18n-timeline']
                            });
                            resolve(true);
                        });
                    }
                    catch (e) {
                        console.error(e);
                        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                        reject(false);
                    }
                })];
        });
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getI18nScopeLable(instance) {
    return (instance.type.name ||
        instance.type.displayName ||
        instance.type.__file ||
        'Anonymous');
}
function updateComponentTreeTags(instance, // eslint-disable-line @typescript-eslint/no-explicit-any
treeNode, i18n) {
    // prettier-ignore
    var global = i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) {
        // add custom tags local scope only
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            var tag = {
                label: "i18n (".concat(getI18nScopeLable(instance), " Scope)"),
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function inspectComposer(instanceData, composer) {
    var type = VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: 'locale',
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: 'availableLocales',
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: 'fallbackLocale',
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: 'inheritLocale',
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: 'messages',
        editable: false,
        value: getLocaleMessageValue(composer.messages.value)
    });
    {
        instanceData.state.push({
            type: type,
            key: 'datetimeFormats',
            editable: false,
            value: composer.datetimeFormats.value
        });
        instanceData.state.push({
            type: type,
            key: 'numberFormats',
            editable: false,
            value: composer.numberFormats.value
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getLocaleMessageValue(messages) {
    var value = {};
    Object.keys(messages).forEach(function (key) {
        var v = messages[key];
        if (isFunction(v) && 'source' in v) {
            value[key] = getMessageFunctionDetails(v);
        }
        else if (isMessageAST(v) && v.loc && v.loc.source) {
            value[key] = v.loc.source;
        }
        else if (isObject(v)) {
            value[key] = getLocaleMessageValue(v);
        }
        else {
            value[key] = v;
        }
    });
    return value;
}
var ESC = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '&': '&amp;'
};
function escape(s) {
    return s.replace(/[<>"&]/g, escapeChar);
}
function escapeChar(a) {
    return ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMessageFunctionDetails(func) {
    var argString = func.source ? "(\"".concat(escape(func.source), "\")") : "(?)";
    return {
        _custom: {
            type: 'function',
            display: "<span>\u0192</span> ".concat(argString)
        }
    };
}
function registerScope(payload, i18n) {
    var e_1, _a;
    payload.rootNodes.push({
        id: 'global',
        label: 'Global Scope'
    });
    // prettier-ignore
    var global = i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
    try {
        for (var _b = __values(i18n.__instances), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), keyInstance = _d[0], instance = _d[1];
            // prettier-ignore
            var composer = i18n.mode === 'composition'
                ? instance
                : instance.__composer;
            if (global === composer) {
                continue;
            }
            payload.rootNodes.push({
                id: composer.id.toString(),
                label: "".concat(getI18nScopeLable(keyInstance), " Scope")
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function getComponentInstance(nodeId, i18n) {
    var e_2, _a;
    var instance = null;
    if (nodeId !== 'global') {
        try {
            for (var _b = __values(i18n.__instances.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), component = _d[0], composer = _d[1];
                if (composer.id.toString() === nodeId) {
                    instance = component;
                    break;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    return instance;
}
function getComposer$2(nodeId, i18n) {
    if (nodeId === 'global') {
        return i18n.mode === 'composition'
            ? i18n.global
            : i18n.global.__composer;
    }
    else {
        var instance = Array.from(i18n.__instances.values()).find(function (item) { return item.id.toString() === nodeId; });
        if (instance) {
            return i18n.mode === 'composition'
                ? instance
                : instance.__composer;
        }
        else {
            return null;
        }
    }
}
function inspectScope(payload, i18n
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    var composer = getComposer$2(payload.nodeId, i18n);
    if (composer) {
        // TODO:
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload.state = makeScopeInspectState(composer);
    }
    return null;
}
function makeScopeInspectState(composer) {
    var state = {};
    var localeType = 'Locale related info';
    var localeStates = [
        {
            type: localeType,
            key: 'locale',
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: 'fallbackLocale',
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: 'availableLocales',
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: 'inheritLocale',
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    var localeMessagesType = 'Locale messages info';
    var localeMessagesStates = [
        {
            type: localeMessagesType,
            key: 'messages',
            editable: false,
            value: getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        var datetimeFormatsType = 'Datetime formats info';
        var datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: 'datetimeFormats',
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        var numberFormatsType = 'Datetime formats info';
        var numberFormatsStates = [
            {
                type: numberFormatsType,
                key: 'numberFormats',
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function addTimelineEvent(event, payload) {
    if (devtoolsApi) {
        var groupId = void 0;
        if (payload && 'groupId' in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        devtoolsApi.addTimelineEvent({
            layerId: 'vue-i18n-timeline',
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === 'compile-error'
                    ? 'error'
                    : event === 'fallback' || event === 'missing'
                        ? 'warning'
                        : 'default'
            }
        });
    }
}
function editScope(payload, i18n) {
    var composer = getComposer$2(payload.nodeId, i18n);
    if (composer) {
        var _a = __read(payload.path, 1), field = _a[0];
        if (field === 'locale' && isString(payload.state.value)) {
            composer.locale.value = payload.state.value;
        }
        else if (field === 'fallbackLocale' &&
            (isString(payload.state.value) ||
                isArray(payload.state.value) ||
                isObject(payload.state.value))) {
            composer.fallbackLocale.value = payload.state.value;
        }
        else if (field === 'inheritLocale' && isBoolean(payload.state.value)) {
            composer.inheritLocale = payload.state.value;
        }
    }
}
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */
function convertComposerOptions(options) {
    var locale = isString(options.locale) ? options.locale : DEFAULT_LOCALE;
    var fallbackLocale = isString(options.fallbackLocale) ||
        isArray(options.fallbackLocale) ||
        isPlainObject(options.fallbackLocale) ||
        options.fallbackLocale === false
        ? options.fallbackLocale
        : locale;
    var missing = isFunction(options.missing) ? options.missing : undefined;
    var missingWarn = isBoolean(options.silentTranslationWarn) ||
        isRegExp(options.silentTranslationWarn)
        ? !options.silentTranslationWarn
        : true;
    var fallbackWarn = isBoolean(options.silentFallbackWarn) ||
        isRegExp(options.silentFallbackWarn)
        ? !options.silentFallbackWarn
        : true;
    var fallbackRoot = isBoolean(options.fallbackRoot)
        ? options.fallbackRoot
        : true;
    var fallbackFormat = !!options.formatFallbackMessages;
    var modifiers = isPlainObject(options.modifiers) ? options.modifiers : {};
    var pluralizationRules = options.pluralizationRules;
    var postTranslation = isFunction(options.postTranslation)
        ? options.postTranslation
        : undefined;
    var warnHtmlMessage = isString(options.warnHtmlInMessage)
        ? options.warnHtmlInMessage !== 'off'
        : true;
    var escapeParameter = !!options.escapeParameterHtml;
    var inheritLocale = isBoolean(options.sync) ? options.sync : true;
    var messages = options.messages;
    if (isPlainObject(options.sharedMessages)) {
        var sharedMessages_1 = options.sharedMessages;
        var locales = Object.keys(sharedMessages_1);
        messages = locales.reduce(function (messages, locale) {
            var message = messages[locale] || (messages[locale] = {});
            assign(message, sharedMessages_1[locale]);
            return messages;
        }, (messages || {}));
    }
    var __i18n = options.__i18n, __root = options.__root, __injectWithOption = options.__injectWithOption;
    var datetimeFormats = options.datetimeFormats;
    var numberFormats = options.numberFormats;
    var flatJson = options.flatJson;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */
function createVueI18n(options) {
    if (options === void 0) { options = {}; }
    var composer = createComposer(convertComposerOptions(options));
    var __extender = options.__extender;
    // defines VueI18n
    var vueI18n = {
        // id
        id: composer.id,
        // locale
        get locale() {
            return composer.locale.value;
        },
        set locale(val) {
            composer.locale.value = val;
        },
        // fallbackLocale
        get fallbackLocale() {
            return composer.fallbackLocale.value;
        },
        set fallbackLocale(val) {
            composer.fallbackLocale.value = val;
        },
        // messages
        get messages() {
            return composer.messages.value;
        },
        // datetimeFormats
        get datetimeFormats() {
            return composer.datetimeFormats.value;
        },
        // numberFormats
        get numberFormats() {
            return composer.numberFormats.value;
        },
        // availableLocales
        get availableLocales() {
            return composer.availableLocales;
        },
        // missing
        get missing() {
            return composer.getMissingHandler();
        },
        set missing(handler) {
            composer.setMissingHandler(handler);
        },
        // silentTranslationWarn
        get silentTranslationWarn() {
            return isBoolean(composer.missingWarn)
                ? !composer.missingWarn
                : composer.missingWarn;
        },
        set silentTranslationWarn(val) {
            composer.missingWarn = isBoolean(val) ? !val : val;
        },
        // silentFallbackWarn
        get silentFallbackWarn() {
            return isBoolean(composer.fallbackWarn)
                ? !composer.fallbackWarn
                : composer.fallbackWarn;
        },
        set silentFallbackWarn(val) {
            composer.fallbackWarn = isBoolean(val) ? !val : val;
        },
        // modifiers
        get modifiers() {
            return composer.modifiers;
        },
        // formatFallbackMessages
        get formatFallbackMessages() {
            return composer.fallbackFormat;
        },
        set formatFallbackMessages(val) {
            composer.fallbackFormat = val;
        },
        // postTranslation
        get postTranslation() {
            return composer.getPostTranslationHandler();
        },
        set postTranslation(handler) {
            composer.setPostTranslationHandler(handler);
        },
        // sync
        get sync() {
            return composer.inheritLocale;
        },
        set sync(val) {
            composer.inheritLocale = val;
        },
        // warnInHtmlMessage
        get warnHtmlInMessage() {
            return composer.warnHtmlMessage ? 'warn' : 'off';
        },
        set warnHtmlInMessage(val) {
            composer.warnHtmlMessage = val !== 'off';
        },
        // escapeParameterHtml
        get escapeParameterHtml() {
            return composer.escapeParameter;
        },
        set escapeParameterHtml(val) {
            composer.escapeParameter = val;
        },
        // pluralizationRules
        get pluralizationRules() {
            return composer.pluralRules || {};
        },
        // for internal
        __composer: composer,
        // t
        t: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Reflect.apply(composer.t, composer, __spreadArray([], __read(args), false));
        },
        // rt
        rt: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Reflect.apply(composer.rt, composer, __spreadArray([], __read(args), false));
        },
        // tc
        tc: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a = __read(args, 3), arg1 = _a[0], arg2 = _a[1], arg3 = _a[2];
            var options = { plural: 1 };
            var list = null;
            var named = null;
            if ((process.env.NODE_ENV !== 'production')) {
                warnOnce(getWarnMessage(I18nWarnCodes.DEPRECATE_TC));
            }
            if (!isString(arg1)) {
                throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
            }
            var key = arg1;
            if (isString(arg2)) {
                options.locale = arg2;
            }
            else if (isNumber(arg2)) {
                options.plural = arg2;
            }
            else if (isArray(arg2)) {
                list = arg2;
            }
            else if (isPlainObject(arg2)) {
                named = arg2;
            }
            if (isString(arg3)) {
                options.locale = arg3;
            }
            else if (isArray(arg3)) {
                list = arg3;
            }
            else if (isPlainObject(arg3)) {
                named = arg3;
            }
            // return composer.t(key, (list || named || {}) as any, options)
            return Reflect.apply(composer.t, composer, [
                key,
                (list || named || {}),
                options
            ]);
        },
        // te
        te: function (key, locale) {
            return composer.te(key, locale);
        },
        // tm
        tm: function (key) {
            return composer.tm(key);
        },
        // getLocaleMessage
        getLocaleMessage: function (locale) {
            return composer.getLocaleMessage(locale);
        },
        // setLocaleMessage
        setLocaleMessage: function (locale, message) {
            composer.setLocaleMessage(locale, message);
        },
        // mergeLocaleMessage
        mergeLocaleMessage: function (locale, message) {
            composer.mergeLocaleMessage(locale, message);
        },
        // d
        d: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Reflect.apply(composer.d, composer, __spreadArray([], __read(args), false));
        },
        // getDateTimeFormat
        getDateTimeFormat: function (locale) {
            return composer.getDateTimeFormat(locale);
        },
        // setDateTimeFormat
        setDateTimeFormat: function (locale, format) {
            composer.setDateTimeFormat(locale, format);
        },
        // mergeDateTimeFormat
        mergeDateTimeFormat: function (locale, format) {
            composer.mergeDateTimeFormat(locale, format);
        },
        // n
        n: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Reflect.apply(composer.n, composer, __spreadArray([], __read(args), false));
        },
        // getNumberFormat
        getNumberFormat: function (locale) {
            return composer.getNumberFormat(locale);
        },
        // setNumberFormat
        setNumberFormat: function (locale, format) {
            composer.setNumberFormat(locale, format);
        },
        // mergeNumberFormat
        mergeNumberFormat: function (locale, format) {
            composer.mergeNumberFormat(locale, format);
        }
    };
    vueI18n.__extender = __extender;
    // for vue-devtools timeline event
    if ((process.env.NODE_ENV !== 'production')) {
        vueI18n.__enableEmitter = function (emitter) {
            var __composer = composer;
            __composer[EnableEmitter] && __composer[EnableEmitter](emitter);
        };
        vueI18n.__disableEmitter = function () {
            var __composer = composer;
            __composer[DisableEmitter] && __composer[DisableEmitter]();
        };
    }
    return vueI18n;
}
/* eslint-enable @typescript-eslint/no-explicit-any */
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */
function defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate: function () {
            var _this = this;
            var instance = getCurrentInstance();
            /* istanbul ignore if */
            if (!instance) {
                throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
            }
            var options = this.$options;
            if (options.i18n) {
                var optionsI18n = options.i18n;
                if (options.__i18n) {
                    optionsI18n.__i18n = options.__i18n;
                }
                optionsI18n.__root = composer;
                if (this === this.$root) {
                    // merge option and gttach global
                    this.$i18n = mergeToGlobal(vuei18n, optionsI18n);
                }
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    var _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) {
                        _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                    }
                }
            }
            else if (options.__i18n) {
                if (this === this.$root) {
                    // merge option and gttach global
                    this.$i18n = mergeToGlobal(vuei18n, options);
                }
                else {
                    // atttach local VueI18n instance
                    this.$i18n = createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    var _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) {
                        _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                    }
                }
            }
            else {
                // attach global VueI18n instance
                this.$i18n = vuei18n;
            }
            if (options.__i18nGlobal) {
                adjustI18nResources(composer, options, options);
            }
            // defines vue-i18n legacy APIs
            this.$t = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_a = _this.$i18n).t.apply(_a, __spreadArray([], __read(args), false));
            };
            this.$rt = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_a = _this.$i18n).rt.apply(_a, __spreadArray([], __read(args), false));
            };
            this.$tc = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_a = _this.$i18n).tc.apply(_a, __spreadArray([], __read(args), false));
            };
            this.$te = function (key, locale) { return _this.$i18n.te(key, locale); };
            this.$d = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_a = _this.$i18n).d.apply(_a, __spreadArray([], __read(args), false));
            };
            this.$n = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_a = _this.$i18n).n.apply(_a, __spreadArray([], __read(args), false));
            };
            this.$tm = function (key) { return _this.$i18n.tm(key); };
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted: function () {
            /* istanbul ignore if */
            if (((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) &&
                !false &&
                this.$el &&
                this.$i18n) {
                var _vueI18n = this.$i18n;
                this.$el.__VUE_I18N__ = _vueI18n.__composer;
                var emitter = (this.__v_emitter =
                    createEmitter());
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on('*', addTimelineEvent);
            }
        },
        unmounted: function () {
            var instance = getCurrentInstance();
            /* istanbul ignore if */
            if (!instance) {
                throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
            }
            var _vueI18n = this.$i18n;
            /* istanbul ignore if */
            if (((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) &&
                !false &&
                this.$el &&
                this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off('*', addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn =
        options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages =
        options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    var messages = getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach(function (locale) { return g.mergeLocaleMessage(locale, messages[locale]); });
    if (options.datetimeFormats) {
        Object.keys(options.datetimeFormats).forEach(function (locale) { return g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]); });
    }
    if (options.numberFormats) {
        Object.keys(options.numberFormats).forEach(function (locale) { return g.mergeNumberFormat(locale, options.numberFormats[locale]); });
    }
    return g;
}
var baseFormatProps = {
    tag: {
        type: [String, Object]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: function (val /* ComponentI18nScope */) { return val === 'parent' || val === 'global'; },
        default: 'parent' /* ComponentI18nScope */
    },
    i18n: {
        type: Object
    }
};
function getInterpolateArg(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
_a, // SetupContext,
keys) {
    var slots = _a.slots;
    if (keys.length === 1 && keys[0] === 'default') {
        // default slot with list
        var ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce(function (slot, current) {
            return __spreadArray(__spreadArray([], __read(slot), false), __read((current.type === Fragment ? current.children : [current])), false);
        }, []);
    }
    else {
        // named slots
        return keys.reduce(function (arg, key) {
            var slot = slots[key];
            if (slot) {
                arg[key] = slot();
            }
            return arg;
        }, create());
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFragmentableTag() {
    return Fragment;
}
var TranslationImpl = /*#__PURE__*/ defineComponent({
    /* eslint-disable */
    name: 'i18n-t',
    props: assign({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [Number, String],
            validator: function (val) { return isNumber(val) || !isNaN(val); }
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup: function (props, context) {
        var slots = context.slots, attrs = context.attrs;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        var i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return function () {
            var keys = Object.keys(slots).filter(function (key) { return key !== '_'; });
            var options = create();
            if (props.locale) {
                options.locale = props.locale;
            }
            if (props.plural !== undefined) {
                options.plural = isString(props.plural) ? +props.plural : props.plural;
            }
            var arg = getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var children = i18n[TranslateVNodeSymbol](props.keypath, arg, options);
            var assignedAttrs = assign(create(), attrs);
            var tag = isString(props.tag) || isObject(props.tag)
                ? props.tag
                : getFragmentableTag();
            return h(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */
/**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */
var Translation = TranslationImpl;
var I18nT = Translation;
function isVNode(target) {
    return isArray(target) && !isString(target[0]);
}
function renderFormatter(props, context, slotKeys, partFormatter) {
    var slots = context.slots, attrs = context.attrs;
    return function () {
        var options = { part: true };
        var overrides = create();
        if (props.locale) {
            options.locale = props.locale;
        }
        if (isString(props.format)) {
            options.key = props.format;
        }
        else if (isObject(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (isString(props.format.key)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                options.key = props.format.key;
            }
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce(function (options, prop) {
                var _a;
                return slotKeys.includes(prop)
                    ? assign(create(), options, (_a = {}, _a[prop] = props.format[prop], _a)) // eslint-disable-line @typescript-eslint/no-explicit-any
                    : options;
            }, create());
        }
        var parts = partFormatter.apply(void 0, [props.value, options, overrides]);
        var children = [options.key];
        if (isArray(parts)) {
            children = parts.map(function (part, index) {
                var _a;
                var slot = slots[part.type];
                var node = slot
                    ? slot((_a = {}, _a[part.type] = part.value, _a.index = index, _a.parts = parts, _a))
                    : [part.value];
                if (isVNode(node)) {
                    node[0].key = "".concat(part.type, "-").concat(index);
                }
                return node;
            });
        }
        else if (isString(parts)) {
            children = [parts];
        }
        var assignedAttrs = assign(create(), attrs);
        var tag = isString(props.tag) || isObject(props.tag)
            ? props.tag
            : getFragmentableTag();
        return h(tag, assignedAttrs, children);
    };
}
var NumberFormatImpl = /*#__PURE__*/ defineComponent({
    /* eslint-disable */
    name: 'i18n-n',
    props: assign({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup: function (props, context) {
        var i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return renderFormatter(props, context, NUMBER_FORMAT_OPTIONS_KEYS, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return i18n[NumberPartsSymbol].apply(i18n, __spreadArray([], __read(args), false));
        });
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */
/**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */
var NumberFormat = NumberFormatImpl;
var I18nN = NumberFormat;
var DatetimeFormatImpl = /* #__PURE__*/ defineComponent({
    /* eslint-disable */
    name: 'i18n-d',
    props: assign({
        value: {
            type: [Number, Date],
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup: function (props, context) {
        var i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return renderFormatter(props, context, DATETIME_FORMAT_OPTIONS_KEYS, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return i18n[DatetimePartsSymbol].apply(i18n, __spreadArray([], __read(args), false));
        });
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */
var DatetimeFormat = DatetimeFormatImpl;
var I18nD = DatetimeFormat;
function getComposer$1(i18n, instance) {
    var i18nInternal = i18n;
    if (i18n.mode === 'composition') {
        return (i18nInternal.__getInstance(instance) || i18n.global);
    }
    else {
        var vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null
            ? vueI18n.__composer
            : i18n.global.__composer;
    }
}
function vTDirective(i18n) {
    var _process = function (binding) {
        var instance = binding.instance, value = binding.value;
        /* istanbul ignore if */
        if (!instance || !instance.$) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        var composer = getComposer$1(i18n, instance.$);
        var parsedValue = parseValue(value);
        return [
            Reflect.apply(composer.t, composer, __spreadArray([], __read(makeParams(parsedValue)), false)),
            composer
        ];
    };
    var register = function (el, binding) {
        var _a = __read(_process(binding), 2), textContent = _a[0], composer = _a[1];
        if (inBrowser && i18n.global === composer) {
            // global scope only
            el.__i18nWatcher = watch(composer.locale, function () {
                binding.instance && binding.instance.$forceUpdate();
            });
        }
        el.__composer = composer;
        el.textContent = textContent;
    };
    var unregister = function (el) {
        if (inBrowser && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    var update = function (el, _a) {
        var value = _a.value;
        if (el.__composer) {
            var composer = el.__composer;
            var parsedValue = parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, __spreadArray([], __read(makeParams(parsedValue)), false));
        }
    };
    var getSSRProps = function (binding) {
        var _a = __read(_process(binding), 1), textContent = _a[0];
        return { textContent: textContent };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function parseValue(value) {
    if (isString(value)) {
        return { path: value };
    }
    else if (isPlainObject(value)) {
        if (!('path' in value)) {
            throw createI18nError(I18nErrorCodes.REQUIRED_VALUE, 'path');
        }
        return value;
    }
    else {
        throw createI18nError(I18nErrorCodes.INVALID_VALUE);
    }
}
function makeParams(value) {
    var path = value.path, locale = value.locale, args = value.args, choice = value.choice, plural = value.plural;
    var options = {};
    var named = args || {};
    if (isString(locale)) {
        options.locale = locale;
    }
    if (isNumber(choice)) {
        options.plural = choice;
    }
    if (isNumber(plural)) {
        options.plural = plural;
    }
    return [path, named, options];
}
function apply(app, i18n) {
    var options = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        options[_i - 2] = arguments[_i];
    }
    var pluginOptions = isPlainObject(options[0])
        ? options[0]
        : {};
    var globalInstall = isBoolean(pluginOptions.globalInstall)
        ? pluginOptions.globalInstall
        : true;
    if (globalInstall) {
        [Translation.name, 'I18nT'].forEach(function (name) { return app.component(name, Translation); });
        [NumberFormat.name, 'I18nN'].forEach(function (name) { return app.component(name, NumberFormat); });
        [DatetimeFormat.name, 'I18nD'].forEach(function (name) { return app.component(name, DatetimeFormat); });
    }
    // install directive
    {
        app.directive('t', vTDirective(i18n));
    }
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */
var I18nInjectionKey = 
/* #__PURE__*/ makeSymbol('global-vue-i18n');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createI18n(options, VueI18nLegacy) {
    if (options === void 0) { options = {}; }
    // prettier-ignore
    var __legacyMode = __VUE_I18N_LEGACY_API__ && isBoolean(options.legacy)
        ? options.legacy
        : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    var __globalInjection = isBoolean(options.globalInjection)
        ? options.globalInjection
        : true;
    var __instances = new Map();
    var _a = __read(createGlobal(options, __legacyMode), 2), globalScope = _a[0], __global = _a[1];
    var symbol = /* #__PURE__*/ makeSymbol((process.env.NODE_ENV !== 'production') ? 'vue-i18n' : '');
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    var i18n = {
        // mode
        get mode() {
            return __VUE_I18N_LEGACY_API__ && __legacyMode
                ? 'legacy'
                : 'composition';
        },
        // install plugin
        install: function (app) {
            var options = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                options[_i - 1] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var opts, globalReleaseHandler, unmountApp, ret, emitter, _vueI18n, _composer;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) && !false) {
                                app.__VUE_I18N__ = i18n;
                            }
                            // setup global provider
                            app.__VUE_I18N_SYMBOL__ = symbol;
                            app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                            // set composer & vuei18n extend hook options from plugin options
                            if (isPlainObject(options[0])) {
                                opts = options[0];
                                i18n.__composerExtend =
                                    opts.__composerExtend;
                                i18n.__vueI18nExtend =
                                    opts.__vueI18nExtend;
                            }
                            globalReleaseHandler = null;
                            if (!__legacyMode && __globalInjection) {
                                globalReleaseHandler = injectGlobalFields(app, i18n.global);
                            }
                            // install built-in components and directive
                            if (__VUE_I18N_FULL_INSTALL__) {
                                apply.apply(void 0, __spreadArray([app, i18n], __read(options), false));
                            }
                            // setup mixin for Legacy API
                            if (__VUE_I18N_LEGACY_API__ && __legacyMode) {
                                app.mixin(defineMixin(__global, __global.__composer, i18n));
                            }
                            unmountApp = app.unmount;
                            app.unmount = function () {
                                globalReleaseHandler && globalReleaseHandler();
                                i18n.dispose();
                                unmountApp();
                            };
                            if (!(((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) && !false)) return [3 /*break*/, 2];
                            return [4 /*yield*/, enableDevTools(app, i18n)];
                        case 1:
                            ret = _a.sent();
                            if (!ret) {
                                throw createI18nError(I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                            }
                            emitter = createEmitter();
                            if (__legacyMode) {
                                _vueI18n = __global;
                                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                            }
                            else {
                                _composer = __global;
                                _composer[EnableEmitter] && _composer[EnableEmitter](emitter);
                            }
                            emitter.on('*', addTimelineEvent);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        // global accessor
        get global() {
            return __global;
        },
        dispose: function () {
            globalScope.stop();
        },
        // @internal
        __instances: __instances,
        // @internal
        __getInstance: __getInstance,
        // @internal
        __setInstance: __setInstance,
        // @internal
        __deleteInstance: __deleteInstance
    };
    return i18n;
}
function useI18n(options) {
    if (options === void 0) { options = {}; }
    var instance = getCurrentInstance();
    if (instance == null) {
        throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    }
    if (!instance.isCE &&
        instance.appContext.app != null &&
        !instance.appContext.app.__VUE_I18N_SYMBOL__) {
        throw createI18nError(I18nErrorCodes.NOT_INSTALLED);
    }
    var i18n = getI18nInstance(instance);
    var gl = getGlobalComposer(i18n);
    var componentOptions = getComponentOptions(instance);
    var scope = getScope(options, componentOptions);
    if (scope === 'global') {
        adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === 'parent') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var composer_1 = getComposer(i18n, instance, options.__useComponent);
        if (composer_1 == null) {
            if ((process.env.NODE_ENV !== 'production')) {
                warn(getWarnMessage(I18nWarnCodes.NOT_FOUND_PARENT_SCOPE));
            }
            composer_1 = gl;
        }
        return composer_1;
    }
    var i18nInternal = i18n;
    var composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        var composerOptions = assign({}, options);
        if ('__i18n' in componentOptions) {
            composerOptions.__i18n = componentOptions.__i18n;
        }
        if (gl) {
            composerOptions.__root = gl;
        }
        composer = createComposer(composerOptions);
        if (i18nInternal.__composerExtend) {
            composer[DisposeSymbol] =
                i18nInternal.__composerExtend(composer);
        }
        setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
function createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    var scope = effectScope();
    var obj = __VUE_I18N_LEGACY_API__ && legacyMode
        ? scope.run(function () { return createVueI18n(options); })
        : scope.run(function () { return createComposer(options); });
    if (obj == null) {
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    return [scope, obj];
}
function getI18nInstance(instance) {
    var i18n = inject(!instance.isCE
        ? instance.appContext.app.__VUE_I18N_SYMBOL__
        : I18nInjectionKey);
    /* istanbul ignore if */
    if (!i18n) {
        throw createI18nError(!instance.isCE
            ? I18nErrorCodes.UNEXPECTED_ERROR
            : I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
    }
    return i18n;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getScope(options, componentOptions) {
    // prettier-ignore
    return isEmptyObject(options)
        ? ('__i18n' in componentOptions)
            ? 'local'
            : 'global'
        : !options.useScope
            ? 'local'
            : options.useScope;
}
function getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
}
function getComposer(i18n, target, useComponent) {
    if (useComponent === void 0) { useComponent = false; }
    var composer = null;
    var root = target.root;
    var current = getParentComponentInstance(target, useComponent);
    while (current != null) {
        var i18nInternal = i18n;
        if (i18n.mode === 'composition') {
            composer = i18nInternal.__getInstance(current);
        }
        else {
            if (__VUE_I18N_LEGACY_API__) {
                var vueI18n = i18nInternal.__getInstance(current);
                if (vueI18n != null) {
                    composer = vueI18n
                        .__composer;
                    if (useComponent &&
                        composer &&
                        !composer[InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                    ) {
                        composer = null;
                    }
                }
            }
        }
        if (composer != null) {
            break;
        }
        if (root === current) {
            break;
        }
        current = current.parent;
    }
    return composer;
}
function getParentComponentInstance(target, useComponent) {
    if (useComponent === void 0) { useComponent = false; }
    if (target == null) {
        return null;
    }
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent
        ? target.parent
        : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function setupLifeCycle(i18n, target, composer) {
    var emitter = null;
    onMounted(function () {
        // inject composer instance to DOM for intlify-devtools
        if (((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) &&
            !false &&
            target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = createEmitter();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var _composer = composer;
            _composer[EnableEmitter] && _composer[EnableEmitter](emitter);
            emitter.on('*', addTimelineEvent);
        }
    }, target);
    onUnmounted(function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if (((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) &&
            !false &&
            target.vnode.el &&
            target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off('*', addTimelineEvent);
            _composer[DisableEmitter] && _composer[DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
        // dispose extended resources
        var dispose = _composer[DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[DisposeSymbol];
        }
    }, target);
}
var globalExportProps = [
    'locale',
    'fallbackLocale',
    'availableLocales'
];
var globalExportMethods = ['t', 'rt', 'd', 'n', 'tm', 'te'];
function injectGlobalFields(app, composer) {
    var i18n = Object.create(null);
    globalExportProps.forEach(function (prop) {
        var desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        var wrap = isRef(desc.value) // check computed props
            ? {
                get: function () {
                    return desc.value.value;
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                set: function (val) {
                    desc.value.value = val;
                }
            }
            : {
                get: function () {
                    return desc.get && desc.get();
                }
            };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    globalExportMethods.forEach(function (method) {
        var desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        Object.defineProperty(app.config.globalProperties, "$".concat(method), desc);
    });
    var dispose = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        globalExportMethods.forEach(function (method) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties["$".concat(method)];
        });
    };
    return dispose;
}
{
    initFeatureFlags();
}
// register message compiler at vue-i18n
registerMessageCompiler(compile);
// register message resolver at vue-i18n
registerMessageResolver(resolveValue);
// register fallback locale at vue-i18n
registerLocaleFallbacker(fallbackWithLocaleChain);
// NOTE: experimental !!
if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) {
    var target = getGlobalThis();
    target.__INTLIFY__ = true;
    setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
if ((process.env.NODE_ENV !== 'production'))
    ;
export { DatetimeFormat, I18nD, I18nInjectionKey, I18nN, I18nT, NumberFormat, Translation, VERSION, createI18n, useI18n, vTDirective };
